import React, {Component, ReactElement, ReactNode} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv, StyledI, StyledSelect, StyledTd} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint, Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {BOARD_AUTHORITY, THREAD_CATEGORY, THREAD_PRIORITY, THREAD_SEARCH} from '../../../CodeMaster'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {Box} from '@mui/material'
import {OptionProps} from '../../../components/shared/forms/PPSelect'
import {DisplayItemSelect, DisplayItemSelectIcon} from '../../../styledComponents/DisplayItem'
import {
    NatGetResidentBulletinBoardThreadList,
    SearchCondition,
    ThreadInfo,
} from '../bulletinBoard/repository/NatGetResidentBulletinBoardThreadList'
import {getThreadContributorLabel, NatAsyncCallFunction} from '../../common/util/Natutil'
import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {PlainBackLink, SmallPlainLink} from '../../../styledComponents/Links'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Location} from 'react-router-dom'

const KEY_BOARD_RESIDET_AUTHORITY = 'boardResidentAuthority'
const KEY_BOARD_ADMIN_AUTHORITY = 'boardAdminAuthority'

interface Props {
    categoryId: string
    bulletinBoardRepo: NatBulletinBoardRepo
    location: Location
}


interface States {
    isLoadCompleted: boolean,
    subTitle: string
    searchCondition: SearchCondition
    threadList: ThreadInfo[]
    initialMessage: string
    boardEditFlag: boolean
}

class NatResidentBulletinBoardThreadListPage extends Component<Props & ResidentPagePropsSet, States> {

    boardResidentAuthority: string
    boardAdminAuthority: string

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
            subTitle: '',
            searchCondition: {
                categoryId: this.props.categoryId,
            },
            threadList: [],
            initialMessage: '',
            boardEditFlag: false,
        }

        this.boardResidentAuthority = SessionStorageHelper.getStringItemWithDefault(KEY_BOARD_RESIDET_AUTHORITY,
            BOARD_AUTHORITY.NONE.value)
        this.boardAdminAuthority = SessionStorageHelper.getStringItemWithDefault(KEY_BOARD_ADMIN_AUTHORITY,
            BOARD_AUTHORITY.NONE.value)

        this.onChangeCategory = this.onChangeCategory.bind(this)
        this.clickThreadRegisterButton = this.clickThreadRegisterButton.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const categoryId = this.props.categoryId
        let subTitle: string = ''
        let boardEditFlag = false
        const threadCategoryCode: THREAD_CATEGORY = THREAD_CATEGORY.codeToEnumConstants(categoryId ?? '0')
        if (threadCategoryCode) {
            subTitle = threadCategoryCode.label
            if (threadCategoryCode.value === THREAD_CATEGORY.RESIDENT.value &&
                this.boardResidentAuthority === BOARD_AUTHORITY.EDIT.value) {
                boardEditFlag = true
            } else if (threadCategoryCode.value === THREAD_CATEGORY.ADMIN.value &&
                this.boardAdminAuthority === BOARD_AUTHORITY.EDIT.value) {
                boardEditFlag = true
            }
        }
        let initialMessage: string = ''

        try {
            await this.searchThread(this.state.searchCondition, true)
            if (this.props.location && this.props.location.state) {
                initialMessage = this.props.location.state.initialMessage
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({
                subTitle: subTitle,
                initialMessage: initialMessage,
                isLoadCompleted: true,
                boardEditFlag,
            })
        }
    }

    async searchThread(searchCondition: SearchCondition, initialDisplay?: boolean): Promise<void> {
        if (!initialDisplay) {
            await this.props.eventEmitter.showLoading()
        }
        try {
            const response: Nullable<NatGetResidentBulletinBoardThreadList> =
                await NatAsyncCallFunction(
                    this.props.bulletinBoardRepo.getResidentBulletinBoardThreadList.bind(
                        this.props.bulletinBoardRepo,
                        searchCondition), this.props.navigate)
            if (response && response.details) {
                this.setState({threadList: response.details.threadInfo})
            }
        } finally {
            if (!initialDisplay) {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    clickThreadRegisterButton(): void {
        this.props.navigate(`/resident/bulletinBoardThreadRegister/${this.props.categoryId}`)
    }


    onChangeCategory(event: React.ChangeEvent<{ value: unknown }>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.threadSearch = event.target.value as string
        this.setState({
            initialMessage: '',
            searchCondition: searchCondition,
        })
        this.searchThread(searchCondition)
    }

    renderCategorySelect(): ReactNode {
        let categoryTypeList: OptionProps[]
        categoryTypeList = THREAD_SEARCH.values().map((threadSearch) => {
            return ({
                label: `${threadSearch.label}`,
                value: `${threadSearch.value}`,
            })
        })
        const categoryOptions = [{
            label: 'すべてを表示',
            value: '',
        }, ...categoryTypeList]

        return (
            <CategorySelectIcon>
                <CategorySelect onChange={this.onChangeCategory}>
                    {categoryOptions.map((category, index) => {
                        return (
                            <option value={category.value} key={index}>{category.label}</option>
                        )
                    })}
                </CategorySelect>
            </CategorySelectIcon>
        )
    }

    renderThreadIcon(priority: string): ReactNode {
        if (priority === THREAD_PRIORITY.IMPORTANT.value) {
            return (
                <ThreadTdIcon rowSpan={3}>
                    <ThreadIconImportantStyle><ThreadTableCellIcon/></ThreadIconImportantStyle>
                </ThreadTdIcon>
            )
        } else {
            return (
                <ThreadTdIcon rowSpan={3}>
                    <ThreadIconNormalStyle><ThreadTableCellIcon/></ThreadIconNormalStyle>
                </ThreadTdIcon>
            )
        }
    }

    renderThreadIconFlex(priority: string): ReactNode {
        if (priority === THREAD_PRIORITY.IMPORTANT.value) {
            return (
                <ThreadIconImportantStyle><ThreadTableCellIcon/></ThreadIconImportantStyle>
            )
        } else {
            return (
                <ThreadIconNormalStyle><ThreadTableCellIcon/></ThreadIconNormalStyle>
            )
        }
    }


    renderThreadRowFlex(threadInfo: ThreadInfo, index: number): Nullable<ReactElement> {
        return (
            <ThreadFlex key={index}>
                <ThreadIconFlex>
                    {this.renderThreadIconFlex(threadInfo.priority)}
                </ThreadIconFlex>
                <ThreadInfoFlex>
                    <ThreadInfoTitleFlex>
                        <ThreadTitleLink to={`/resident/bulletinBoardThread/${threadInfo.threadId}`}>
                            {threadInfo.title}
                        </ThreadTitleLink>
                    </ThreadInfoTitleFlex>

                    <ThreadInfosFlex>
                        <ThreadInfoOthre>
                            <ThreadInfoContributor>{getThreadContributorLabel(threadInfo.contributorRidgeName,
                                threadInfo.contributorRoomNumber,
                                threadInfo.contributorFamilyName,
                                threadInfo.contributorFirstName,
                                threadInfo.contributorRoleName)}
                            </ThreadInfoContributor>
                            <ThreadInfoUpdateDatetime>
                                {`${formatDateTimeForUpdateDate(`${threadInfo.updateDatetime}+09:00`)} 更新`}
                            </ThreadInfoUpdateDatetime>
                            <ThreadInfoNumbers>
                                {`返信：${threadInfo.replyCount}　既読：${threadInfo.alreadyReadCount}`}
                            </ThreadInfoNumbers>
                        </ThreadInfoOthre>
                    </ThreadInfosFlex>
                </ThreadInfoFlex>
            </ThreadFlex>
        )
    }


    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ContentsMainTitle><TitleIcon/>情報交換掲示板</ContentsMainTitle>
                {(this.state.subTitle) ?
                    <ContentsSubTitleWrapper>
                        <ContentsSubTitleInner>
                            {this.state.subTitle}
                        </ContentsSubTitleInner>
                    </ContentsSubTitleWrapper> : <></>
                }
                {(this.state.initialMessage) ?
                    <InitialMessage>
                        {this.state.initialMessage}
                    </InitialMessage> : <></>
                }
                {/* tslint:disable-next-line:max-line-length */}
                <BulletinBoardExplanation>情報交換掲示板は管理組合の皆様による相互の情報交換のための掲示板です。そのため、必ずしもご回答があるとは限りませんので、ご理解の上ご利用をお願い致します。</BulletinBoardExplanation>
                {(this.state.boardEditFlag) ?
                    <Box padding={'15px 0 15px 0'}>
                        <PrimaryStyledButton
                            onClick={this.clickThreadRegisterButton}
                            disabled={false}>
                            スレッド作成
                        </PrimaryStyledButton>
                    </Box>
                    : <></>
                }
                <Box padding={'15px 0 15px 0'}>
                    {this.renderCategorySelect()}
                </Box>
                <MainContainer>
                    {(this.state.threadList.length > 0) ?
                        <ThreadArea>
                            {this.state.threadList.map((threadInfo, index) => (
                                this.renderThreadRowFlex(threadInfo, index)

                            ))}</ThreadArea> : <>選択条件のスレッドはありません</>
                    }
                </MainContainer>

                <BlockSpacer height={'20px'}/>
                <PlainBackLink to={`/resident/bulletinBoard`}>
                    カテゴリ一覧へ戻る
                </PlainBackLink>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentBulletinBoardThreadListPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #4dba78;

  &::before {
      content: "\f111";
  }
`

export const BulletinBoardExplanation = styled(PreformattedDiv)`
  color: ${Colors.Alert};
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Body};
  padding: 10px 0;
`

export const InitialMessage = styled(PreformattedDiv)`
  background-color: rgb(0, 131, 138);
  color: white;
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Body};
  padding: 10px;
`

const CategorySelect: StyledSelect = styled(DisplayItemSelect)`
width: 30%
${breakPoint.lessThan('sp')`
  width: 85%
`}
`

const CategorySelectIcon = styled(DisplayItemSelectIcon)`
  &:after {
    right: 72%;
  }

  ${breakPoint.lessThan('sp')`
   &:after {
      right: 20%;
  }
`}
`


const ThreadFlex: StyledDiv = styled.div`
  padding: 8px 0;
  display: flex;
`

const ThreadTdIcon: StyledTd = styled.td`
`

const ThreadIconStyle: StyledDiv = styled.div`
  ${IconFont};
  font-size: 5.0rem;
  padding-right: 12px;
  color: white;
  ${breakPoint.lessThan('sp')`
    padding-right: 12.5px;
    font-size: 5.5rem;
  `}
`

const ThreadIconNormalStyle = styled(ThreadIconStyle)`
  background-color: grey;
`

const ThreadIconImportantStyle = styled(ThreadIconStyle)`
  background-color: red;
`

const ThreadTableCellIcon: StyledI = styled.i`
  &::before {
      content: "\f111";
  }
`


const ThreadTitleLink = styled(SmallPlainLink)`
  font-size: 2.2rem;
  text-decoration: underline;
  ${breakPoint.lessThan('sp')`
    font-size: 2.0rem;
  `}
`

const ThreadArea: StyledDiv = styled.div`
  border: none;
  width: 100%;

  ${breakPoint.lessThan('sp')`
    display: block;
  `}
`

const ThreadIconFlex: StyledDiv = styled.div`
`

const ThreadInfoFlex: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 15px;
`

const ThreadInfoTitleFlex: StyledDiv = styled.div`
  display: flex;
`

const ThreadInfosFlex: StyledDiv = styled.div`
  font-size: 1.1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  ${breakPoint.lessThan('sp')`
    font-size: 1.0rem;
  `}
`

const ThreadInfoOthre: StyledDiv = styled.div`
  display: flex;
  width: 100%;
  ${breakPoint.lessThan('sp')`
    display: flex;
    flex-direction: column;
  `}
`

const ThreadInfoContributor: StyledDiv = styled.div`
  flex-basis: 50%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
 `}
`

const ThreadInfoUpdateDatetime: StyledDiv = styled.div`
  flex-basis: 25%;
  ${breakPoint.lessThan('sp')`
   flex-basis: 100%;
 `}
`

const ThreadInfoNumbers: StyledDiv = styled.div`
  flex-basis: 25%;
  text-align: center;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
    text-align: left;
 `}
`
